import type { MonospacePolicyEntitlementResource } from '#layers/access/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const SystemEntitlementResource = withItemType<MonospacePolicyEntitlementResource>().defineCollection({
	name: 'SystemEntitlementResource',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.name,
	meta: {
		endpoint: 'entitlements',
		parse: { many: (response) => response.resources },
	},
});
